import { load } from "@cashfreepayments/cashfree-js";

let cashfreeInstance = null;

// ✅ Common function to initialize Cashfree SDK safely
export const initializeCashfree = async () => {
    try {
        // Check if keys exist before initializing
        // const appId = process.env.REACT_APP_CASHFREE_APP_ID;
        // const secretKey = process.env.REACT_APP_CASHFREE_SECRET_KEY;

        const appId = '';
        const secretKey = '';
        if (!appId || !secretKey) {
            console.warn("Cashfree environment variables missing, skipping SDK init.");
            return null;
        }

        // Load SDK only once
        if (!cashfreeInstance) {
            cashfreeInstance = await load({ mode: "production" });
            console.log("✅ Cashfree SDK initialized successfully");
        }

        return cashfreeInstance;
    } catch (error) {
        console.error("Error initializing Cashfree SDK:", error);
        return null;
    }
};
